import SvgSprite from '@Web/Src/Components/SvgSprite';
import { useState, useRef } from 'react';
import PropTypes from 'prop-types';

function Collapse({ title, children, className = '' }) {
    const [isOpen, setIsOpen] = useState(false);
    const contentRef = useRef(null);
    const toggleAccordion = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div
            className={`bg-surface-light main-shadow medium:p-4 medium:text-base small:p-4 mx-4 mt-3 !rounded-3xl p-6 text-xl ${className}`}
        >
            <div
                onClick={toggleAccordion}
                className={`text-dark relative flex w-full cursor-pointer items-center justify-between text-left focus:outline-none`}
            >
                <h3 className='font-bold'>{title}</h3>

                <SvgSprite
                    collectionName={'pricing-icons-sprite'}
                    className={`text-dark duration-400 ml-2 !size-6 flex-shrink-0 transition-transform ease-linear ${isOpen ? 'rotate-180' : 'rotate-0'}`}
                    iconId='arrow-down'
                />
            </div>

            <div
                className={`overflow-hidden transition-all duration-300`}
                style={{
                    maxHeight: isOpen ? `${contentRef.current.scrollHeight}px` : '0',
                }}
                ref={contentRef}
            >
                <div className={'mt-4 text-base'}>{children}</div>
            </div>
        </div>
    );
}

Collapse.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    helpText: PropTypes.string,
    success: PropTypes.bool,
    size: PropTypes.oneOf(['medium', 'large']),
};

export default Collapse;
